import type { Point } from "./Point";

export class BezierSegmentControlPoint
{

    P1: Point;
    P2: Point;

    constructor( p1: Point, p2: Point )
    {
        this.P1 = p1;
        this.P2 = p2;
    }
    
}